import Vue from 'vue'
import Router from 'vue-router'
import special from './routers/special.js'
let common = {
    path: '*',
    redirect: '404.xhtml'
}
Vue.use(Router)
export default new Router({ 
    mode: typeof (history.pushState) === 'function'?'history':'hash',
    base: process.env.BASE_URL,
    routes: [].concat(special,common)
});

/*点击菜单栏时，发现点击路由跳转相同地址 会有这个报错  Uncaught (in promise) NavigationDuplicated {_name: "NavigationDuplicated", name: "NavigationDuplicated"}*/
//此方法解决
const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}